import { Component, computed, input, ViewEncapsulation } from '@angular/core';
import { marked } from 'marked';
import { parseMarkdownSafely } from './safe-marked-renderer';

@Component({
  selector: 'wbi-markdown',
  template: `<div [innerHTML]="parsedHtml()"></div>`,
  styleUrls: ['./markdown.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true,
})
export class MarkdownComponent {
  markdown = input<string>();

  /**
   * Allow images and external links through. Defaults to FALSE because the main consumer is the AI
   * chat, where the text is model-authored and a remote image URL is a zero-click exfiltration
   * channel (see `safe-marked-renderer.ts`). Only set it for first-party content that genuinely
   * needs outbound links, e.g. the legal dialog.
   */
  allowExternal = input(false);

  parsedHtml = computed(() => {
    const source = this.markdown() || '';
    return this.allowExternal() ? (marked.parse(source, { async: false }) as string) : parseMarkdownSafely(source);
  });
}
